/**
 * The Config API client, built once at module load.
 *
 * MSAL is imported dynamically so its chunk loads only when the first request
 * asks for a token, not on the critical path of the first paint.
 */

import { createHttpApi, type ConfigApi, type TokenProvider } from './client'
import { API_BASE_URL } from '../config'

const tokenProvider: TokenProvider = async () => {
  const { acquireToken } = await import('../auth/msal')
  return acquireToken()
}

export const api: ConfigApi = createHttpApi(API_BASE_URL, tokenProvider)

export { ApiError } from './client'
export type { ConfigApi, ListParams, AuditParams } from './client'
